export default function displayAsMoney(value: number | undefined) {
    if(value || value === 0){
        return value.toLocaleString("en-US", {style:"currency", currency:"USD"});
    }
    return "";
}